import { DangerModal } from '@/lib/core/components/Modal'

export type GeoFenceDeleteDialogProps = {
  isOpen: boolean
  geofenceTitle: string
  isDeleting?: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const GeoFenceDeleteDialog = ({
  isOpen,
  geofenceTitle,
  isDeleting = false,
  onCancel,
  onConfirm,
}: GeoFenceDeleteDialogProps) => {
  return (
    <DangerModal
      isActive={isOpen}
      title={`Delete Geofence "${geofenceTitle}"?`}
      onCancel={onCancel}
      onConfirm={onConfirm}
      cancelLabel="Cancel"
      confirmLabel={isDeleting ? 'Deleting...' : 'Delete'}
      confirmProps={{ disabled: isDeleting }}
      cancelProps={{ disabled: isDeleting }}
    >
      <div>
        <p>Are you sure you want to delete &quot;{geofenceTitle}&quot;?</p>
        <p>This action cannot be undone.</p>
      </div>
    </DangerModal>
  )
}
